import { render, staticRenderFns } from "./HomeTagCard.vue?vue&type=template&id=9d75cd84&scoped=true"
import script from "./HomeTagCard.vue?vue&type=script&lang=ts"
export * from "./HomeTagCard.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./HomeTagCard.vue?vue&type=style&index=0&id=9d75cd84&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9d75cd84",
  "6af47e96"
  
)

export default component.exports